//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Table from "@/components/FilterTable/Table.vue";

const DEFAULT_FORMAT = (value) => (value ? value : "N/A");

export default {
  name: "TraitsTable",
  props: ["tableClass", "bordered", "data", "recordsTotal", "loading"],
  components: {
    Table,
  },
  mounted: function () {
    this.columns = [
      {
        name: "ean",
        required: false,
        label: "EAN",
        align: "left",
        field: (row) => row.ean,
        format: DEFAULT_FORMAT,
        sortable: true,
      },
      {
        name: "name",
        required: false,
        align: "left",
        label: "Nome",
        field: (row) => row.name,
        format: DEFAULT_FORMAT,
        sortable: true,
      },
      {
        name: "gross-weight",
        required: false,
        align: "left",
        label: "Peso Bruto",
        field: (row) => row.gross_weight,
        format: DEFAULT_FORMAT,
        sortable: true,
      },
      {
        name: "net-weight",
        required: false,
        align: "left",
        label: "Peso Líquido",
        field: (row) => row.net_weight,
        format: DEFAULT_FORMAT,
        sortable: true,
      },
      {
        name: "weight-units",
        required: false,
        align: "left",
        label: "Unidade de peso",
        field: (row) => (row.weight_unit ? row.weight_unit.name : null),
        format: DEFAULT_FORMAT,
        sortable: true,
      },
      {
        name: "volume",
        required: false,
        align: "left",
        label: "Volume",
        field: (row) => row.volume,
        format: DEFAULT_FORMAT,
        sortable: true,
      },
      {
        name: "volume-unit",
        required: false,
        align: "left",
        label: "Unidade de volume",
        field: (row) => (row.volume_unit ? row.volume_unit.name : null),
        format: DEFAULT_FORMAT,
        sortable: true,
      },
      {
        name: "package-height",
        required: false,
        align: "left",
        label: "Altura da embalagem",
        field: (row) => row.package_height,
        format: DEFAULT_FORMAT,
        sortable: true,
      },
      {
        name: "package-width",
        required: false,
        align: "left",
        label: "Largura da embalagem",
        field: (row) => row.package_width,
        format: DEFAULT_FORMAT,
        sortable: true,
      },
      {
        name: "package-depth",
        required: false,
        align: "left",
        label: "Profundidade da embalagem",
        field: (row) => row.package_depth,
        format: DEFAULT_FORMAT,
        sortable: true,
      },
      {
        name: "box-height",
        required: false,
        align: "left",
        label: "Altura da caixa",
        field: (row) => row.box_height,
        format: DEFAULT_FORMAT,
        sortable: true,
      },
      {
        name: "box-width",
        required: false,
        align: "left",
        label: "Largura da caixa",
        field: (row) => row.box_width,
        format: DEFAULT_FORMAT,
        sortable: true,
      },
      {
        name: "box-depth",
        required: false,
        align: "left",
        label: "Profundidade da caixa",
        field: (row) => row.box_depth,
        format: DEFAULT_FORMAT,
        sortable: true,
      },
      {
        name: "box-ean",
        required: false,
        align: "left",
        label: "EAN da caixa",
        field: (row) => row.box_ean,
        format: DEFAULT_FORMAT,
        sortable: true,
      },
      {
        name: "box-unit-number",
        required: false,
        align: "left",
        label: "Unidades por caixa",
        field: (row) => row.box_unit_number,
        format: DEFAULT_FORMAT,
        sortable: true,
      },
      {
        name: "box-gross-weight",
        required: false,
        align: "left",
        label: "Peso bruto da caixa",
        field: (row) => row.box_gross_weight,
        format: DEFAULT_FORMAT,
        sortable: true,
      },
      {
        name: "box-net-weight",
        required: false,
        align: "left",
        label: "Peso líquido da caixa",
        field: (row) => row.box_net_weight,
        format: DEFAULT_FORMAT,
        sortable: true,
      },
      {
        name: "boxes-per-stack",
        required: false,
        align: "left",
        label: "Caixas por palete",
        field: (row) => row.packages_layers * row.boxes_in_layers,
        format: DEFAULT_FORMAT,
        sortable: true,
      },
      {
        name: "package-layers",
        required: false,
        align: "left",
        label: "Camadas por palete",
        field: (row) => row.packages_layers,
        format: DEFAULT_FORMAT,
        sortable: true,
      },
      {
        name: "boxes-in-layers",
        required: false,
        align: "left",
        label: "Caixas por camada",
        field: (row) => row.boxes_in_layers,
        format: DEFAULT_FORMAT,
        sortable: true,
      },
      {
        name: "units-per-pallet",
        required: false,
        align: "left",
        label: "Unidades por palete",
        field: (row) =>
          row.packages_layers * row.boxes_in_layers * row.box_unit_number,
        format: DEFAULT_FORMAT,
        sortable: true,
      },
      {
        name: "pallet-width",
        required: false,
        align: "left",
        label: "Largura da palete",
        field: (row) => row.pallet_width,
        format: DEFAULT_FORMAT,
        sortable: true,
      },
      {
        name: "pallet-height",
        required: false,
        align: "left",
        label: "Altura da palete",
        field: (row) => row.pallet_height,
        format: DEFAULT_FORMAT,
        sortable: true,
      },
      {
        name: "pallet-depth",
        required: false,
        align: "left",
        label: "Profundidade da palete",
        field: (row) => row.pallet_depth,
        format: DEFAULT_FORMAT,
        sortable: true,
      },
      {
        name: "pallet-weight",
        required: false,
        align: "left",
        label: "Peso da palete",
        field: (row) => row.pallet_weight,
        format: DEFAULT_FORMAT,
        sortable: true,
      },
      {
        name: "batch-number",
        required: false,
        align: "left",
        label: "Número de lote",
        field: (row) => row.batch_number,
        format: DEFAULT_FORMAT,
        sortable: true,
      },
      {
        name: "shelf-life",
        required: false,
        align: "left",
        label: "Validade",
        field: (row) => row.shelf_life,
        format: DEFAULT_FORMAT,
        sortable: true,
      },
    ];
  },
  data: () => ({
    separator: "horizontal",
    columns: [],
  }),
  methods: {
    renderRightSide: function (event) {
      this.$emit("clicked-row", { ...event });
    },
    updateFilter: function (event) {
      this.$emit("filter-changed", event);
    },
  },
};
